<div class="production-by-chimney">
    <div
        class="chart-container"
        #chartTarget
        style="width: 100%"
        [ngClass]="{ 'd-none': !hasData }"
    ></div>
</div>
